import { render } from "./StatesContent.vue?vue&type=template&id=634faa25&ts=true"
import script from "./StatesContent.vue?vue&type=script&lang=ts"
export * from "./StatesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__